import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { BreakpointService } from '@services/breakpoint/breakpoint.service';
import { PositionLoader } from 'cve-ui';

@Component({
    selector: 'app-base',
    imports: [],
    template: '',
})
export class Base implements OnInit {
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly router = inject(Router);
    protected breakpoint = '';
    protected positionLoader!: PositionLoader;
    protected _breakpointService = inject(BreakpointService);

    ngOnInit(): void {
        this._breakpointService.breakpoint$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((breakpoint) => {
            this.breakpoint = breakpoint;
            this.positionLoader =
                (this.router.url.includes('registration') || this.router.url.includes('login')) && !this._breakpointService.minorEqual('tablet')
                    ? PositionLoader.right
                    : PositionLoader.center;
        });
    }
}
